// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2gMcl","inner":"Form_inner__3zw82","range":"Form_range__ZXmGY","name":"Form_name__yDRkJ","actions":"Form_actions__2Dxrk"};